// injects things into the global to make frontend not crash
import '@fhs-legacy/frontend/src/polyfill';
import '@fhs-legacy/frontend/src/styles/theme';
import 'expo-router/entry';
